module.exports = __webpack_public_path__ + "static/img/tit2.e25fc3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tit2.png
// module id = LcXa
// module chunks = 1